// Service Crédits & Paiement.
import { getRequest, postRequest } from "./api/apiService";

export const fetchCredits = () => getRequest("/api/credits");
export const fetchPacks = () => getRequest("/api/credits/packs");
export const checkoutPack = (packId) => postRequest("/api/credits/checkout", { packId });
export const fetchPaymentStatus = () => getRequest("/api/payment/status");
